/* eslint-disable import/max-dependencies */
import React, { useEffect, useState } from "react";
import type { FC } from "react";
import type { Dispatch } from "redux";
import { bindActionCreators } from "redux";
import {
  Box, Button, TextField, Typography,
} from "@mui/material";
import { Autocomplete } from "@mui/lab";
import { KeyboardArrowRight } from "@mui/icons-material";
import { connect } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getDictionarySaga } from "../../actions/dictionaries";
import type { GetDictionarySaga } from "../../actions/dictionaries";
import { getDictionary } from "../../selectors/dictionaries";
import type { State } from "../../store";
import type { DropDownObjItemType } from "../../reducers/dictionaries";
import { PERFORMER } from "../../store";

export type OwnProps = Readonly<{
  onNext: (values: string[]) => void,
}>;

export type StateToProps = Readonly<{
  productCompaniesDropdown: DropDownObjItemType[],
}>;

export type DispatchToProps = Readonly<{
  onGetProductCompaniesDropdownData: () => void,
}>;

export type Props = Readonly<OwnProps & StateToProps & DispatchToProps>;

type CompanyOption = {
  label: string;
  value: string;
};

const mapStateToProps: (state: State) => StateToProps = (state) => ({
  productCompaniesDropdown: getDictionary(state, "productCompany"),
});

const mapDispatchToProps: (arg0: Dispatch<any>) => DispatchToProps = dispatch => bindActionCreators({
  onGetProductCompaniesDropdownData: (): GetDictionarySaga => getDictionarySaga("productCompany", { performer: PERFORMER }),
}, dispatch);

const useStyles = makeStyles((theme) => ({
  input: {
    paddingBottom: theme.spacing(2),
  },
}));

const SelectProductCompanyField: FC<Props> = ({
  onNext,
  productCompaniesDropdown,
  onGetProductCompaniesDropdownData,
}: Props) => {
  const classes = useStyles();
  const [company, setCompany] = useState<DropDownObjItemType | null>(null);
  const [options, setOptions] = useState<any[]>([]);

  useEffect(() => {
    onGetProductCompaniesDropdownData();
  }, []);

  useEffect(() => {
    const list = productCompaniesDropdown.map(({ label }) => ({
      label,
      value: label,
    }));
    setOptions([
      { label: "All", value: list.map(({ label }) => label) },
      ...list,
    ]);
  }, [productCompaniesDropdown]);

  const handleSubmit = () => {
    if (company) {
      onNext(Array.isArray(company.value) ? company.value : [company.value]);
    }
  };

  return (
    <>
      <Typography variant="body2">
        Choose Company
      </Typography>
      <Autocomplete
        id="combo-box"
        options={options}
        value={company}
        onChange={(e, value) => setCompany(value)}
        getOptionLabel={(option: DropDownObjItemType ) => String(option.label)}
        isOptionEqualToValue={(option: DropDownObjItemType, value: DropDownObjItemType) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            margin="dense"
            required
            fullWidth
            size="small"
            placeholder="Choose from the list"
          />
        )}
        fullWidth
        size="small"
        className={classes.input}
      />
      <Button
        fullWidth
        variant="contained"
        color="primary"
        name="loginButton"
        onClick={handleSubmit}
        endIcon={<KeyboardArrowRight />}
        disabled={!company}
      >
        <Box width="100%">Log In</Box>
      </Button>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectProductCompanyField);
